import React, { Component } from 'react';
import Autosuggest from 'react-autosuggest';

// Teach Autosuggest how to calculate suggestions for any given input value.
const getSuggestions = (value, procesos) => {

    if (value === undefined || procesos == undefined)
        return [];

    const inputValue = value.toString().trim().toLowerCase();
    const inputLength = inputValue.length;

    return inputLength === 0 ? [] : procesos.filter(proc => proc.numero == inputValue || proc.fecha.slice(0, inputLength) === inputValue);
};

const getSuggestionValue = suggestion => (suggestion.numero + "-" + " (" + suggestion.fecha + ")");

class AutocompleteProcesos extends Component {
    constructor() {
        super();
        this.state = { value: '', suggestions: [] };
    }

    onChange(event, { newValue, method }) {

        if (method === 'type')
            this.setState({ value: newValue });
        else {
            event.preventDefault();
            event.stopPropagation();
        }
    }

    onSuggestionsFetchRequested({ value }) {
        const { procesos } = this.props;
        this.setState({
            suggestions: getSuggestions(value, procesos)
        });
    }

    onSuggestionsClearRequested() {
        this.setState({ suggestions: [] });
    }

    ClickSuggestions(props, suggestion) {


        const { cambiarFila, cambiarRangoPagina, procesos } = this.props;

        cambiarFila(suggestion);

        const totalProcesos = procesos.length;

        var inicio = totalProcesos;
        var cajaActual = 0;
        var cajaEncontrada = false;
        while (cajaEncontrada == false) {
            var fin = inicio - 9;
            if (fin < 0) {
                cajaEncontrada = true;
                cambiarRangoPagina(cajaActual)

            } else {
                if (suggestion.numero > fin && suggestion.numero <= inicio) {
                    cajaEncontrada = true;
                    cambiarRangoPagina(cajaActual)
                } else {
                    inicio = fin;
                }
            }
            cajaActual++;
        }
    }

    render() {

        const { value, suggestions, rangoElegido } = this.state;
        const { placeholder, cambiarFila } = this.props;
        const inputProps = {
            placeholder: placeholder,
            value: value,
            onChange: this.onChange.bind(this),
            className: "InputProcesos form-control"
        };

        const renderSuggestion = suggestion => (
            <div onClick={() => this.ClickSuggestions(this.props, suggestion)}>
                {suggestion.numero} ({suggestion.fecha})
            </div>
        );

        if (value === undefined)
            return null;

        return (
            <Autosuggest
                suggestions={suggestions}
                onSuggestionsFetchRequested={this.onSuggestionsFetchRequested.bind(this)}
                onSuggestionsClearRequested={this.onSuggestionsClearRequested.bind(this)}
                getSuggestionValue={getSuggestionValue}
                renderSuggestion={renderSuggestion}
                inputProps={inputProps}
            />
        );
    }
}


export default AutocompleteProcesos;